export const storeOseTrackingId = (
  trackingValue: string,
  overwrite = false
) => {
  const saveValue = () =>
    localStorage.setItem(
      "oseTrackingId",
      JSON.stringify({ value: trackingValue, timestamp: Date.now() })
    );

  if (overwrite) {
    saveValue();
    return;
  }

  const SIXTY_DAYS_MS = 60 * 24 * 60 * 60 * 1000;
  const stored = localStorage.getItem("oseTrackingId");

  if (stored) {
    try {
      const { timestamp } = JSON.parse(stored);
      const isExpired = Date.now() - timestamp > SIXTY_DAYS_MS;
      if (isExpired) {
        saveValue();
      }
    } catch {
      saveValue();
    }
  } else {
    saveValue();
  }
};

export function getOseTrackingId(): string | undefined {
  try {
    const stored = localStorage.getItem("oseTrackingId");
    if (stored) {
      return JSON.parse(stored).value;
    }
  } catch {
    return undefined;
  }
  return undefined;
}
